{
  "entry": {
    "title": "Nhập Y Lệnh",
    "subtitle": "Nhập y lệnh điện tử của nhà cung cấp (CPOE)",
    "searchSection": {
      "title": "Tìm & Thêm Y Lệnh",
      "cosignNotice": "Y lệnh của bạn yêu cầu đồng ký của bác sĩ phụ trách trước khi kích hoạt."
    },
    "pending": {
      "title": "Y Lệnh Chờ Gửi",
      "clearAll": "Xóa Tất Cả",
      "collapseAria": "Thu gọn chi tiết",
      "expandAria": "Mở rộng chi tiết",
      "removeAria": "Xóa y lệnh",
      "startDateTime": "Ngày/Giờ Bắt Đầu",
      "ariaStartDate": "Ngày bắt đầu y lệnh",
      "ariaStartTime": "Giờ bắt đầu y lệnh",
      "clinicalIndication": "Chỉ Định Lâm Sàng",
      "clinicalIndicationPlaceholder": "Lý do ra y lệnh…",
      "specialInstructions": "Hướng Dẫn Đặc Biệt",
      "specialInstructionsPlaceholder": "Hướng dẫn bổ sung cho bộ phận thực hiện…",
      "diagnosisLabel": "Chẩn Đoán (ICD-10)",
      "diagnosisPlaceholder": "Tìm mã chẩn đoán ICD-10…",
      "noActiveEncounter": "Không có lần khám đang hoạt động — không thể ra y lệnh.",
      "placing": "Đang gửi…",
      "placeAll": "Gửi Tất Cả Y Lệnh ({{count}})"
    },
    "active": {
      "title": "Y Lệnh Đang Hoạt Động",
      "loading": "Đang tải y lệnh…",
      "emptyAll": "Không tìm thấy y lệnh nào cho bệnh nhân này.",
      "emptyFiltered": "Không tìm thấy y lệnh {{type}}.",
      "columns": {
        "orderNumber": "Số Y Lệnh",
        "name": "Tên",
        "type": "Loại",
        "priority": "Ưu Tiên",
        "status": "Trạng Thái",
        "orderedBy": "Người Ra Y Lệnh",
        "orderedDate": "Ngày Ra Y Lệnh",
        "actions": "Thao Tác"
      },
      "external": "Bên Ngoài",
      "externalTitle": "Y lệnh bên ngoài từ {{source}}",
      "externalTitleWithId": "Y lệnh bên ngoài từ {{source}} (#{{id}})",
      "providerPlaceholder": "Bác sĩ #{{id}}",
      "actions": {
        "complete": "Hoàn Thành",
        "cancel": "Hủy",
        "completeTooltip": "Hoàn thành y lệnh",
        "cancelTooltip": "Hủy y lệnh"
      }
    },
    "cancelDialog": {
      "title": "Hủy Y Lệnh",
      "prompt": "Vui lòng cung cấp lý do hủy {{orderName}}.",
      "placeholder": "Lý do hủy (bắt buộc)…",
      "goBack": "Quay Lại",
      "confirm": "Xác Nhận Hủy"
    },
    "toast": {
      "cancelSuccess": "Đã hủy y lệnh thành công",
      "cancelError": "Không thể hủy y lệnh",
      "completeSuccess": "Y lệnh đã được đánh dấu hoàn thành",
      "completeError": "Không thể hoàn thành y lệnh",
      "noActiveEncounter": "Không tìm thấy lần khám đang hoạt động cho bệnh nhân này. Vui lòng tạo lần khám trước.",
      "placedSuccess_one": "{{count}} y lệnh đã được gửi thành công",
      "placedSuccess_other": "{{count}} y lệnh đã được gửi thành công",
      "medicationFieldsRequired_one": "{{names}} cần liều dùng, đường dùng và tần suất trước khi kê đơn",
      "medicationFieldsRequired_other": "{{count}} thuốc cần liều dùng, đường dùng và tần suất: {{names}}",
      "medicationNotInFormulary_one": "{{names}} chưa được liên kết với danh mục thuốc nên không thể kiểm tra dị ứng, tương tác hay liều — hãy kê đơn từ trang thuốc",
      "medicationNotInFormulary_other": "{{count}} thuốc chưa được liên kết với danh mục thuốc nên không thể kiểm tra: {{names}} — hãy kê đơn từ trang thuốc",
      "placedError_one": "{{count}} y lệnh gửi thất bại",
      "placedError_other": "{{count}} y lệnh gửi thất bại",
      "orderSetApplied": "Đã thêm {{count}} y lệnh từ {{name}} — xem lại trước khi ký"
    }
  },
  "catalog": "Danh mục y lệnh",
  "orderedBy": "Bác sĩ chỉ định",
  "orderedDate": "Ngày chỉ định",
  "scheduledDate": "Ngày dự kiến",
  "completedDate": "Ngày hoàn thành",
  "lab": "Xét nghiệm",
  "imaging": "Chẩn đoán hình ảnh",
  "medication": "Thuốc",
  "procedure": "Thủ thuật",
  "consultation": "Hội chẩn",
  "priority": {
    "label": "Mức ưu tiên",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "Khẩn",
      "routine": "Thường quy",
      "scheduled": "Đã lên lịch",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "Trạng thái y lệnh",
    "values": {
      "draft": "Nháp",
      "pending": "Chờ xử lý",
      "pendingCosign": "Chờ đồng ký",
      "signed": "Đã ký",
      "sent": "Đã gửi",
      "active": "Đang hiệu lực",
      "ordered": "Đã chỉ định",
      "inProgress": "Đang thực hiện",
      "holdForVerify": "Chờ xác nhận",
      "completed": "Hoàn thành",
      "cancelled": "Đã hủy",
      "discontinued": "Đã ngưng",
      "archived": "Đã lưu trữ",
      "pendingClarification": "Chờ làm rõ",
      "suspended": "Tạm ngưng",
      "unknown": "Không rõ"
    }
  },
  "entryFields": {
    "searchPlaceholder": "Tìm y lệnh (xét nghiệm, hình ảnh, thuốc, thủ thuật)…",
    "frequency": "Tần suất",
    "dose": "Liều",
    "route": "Đường dùng",
    "indication": "Chỉ định",
    "duration": "Thời gian",
    "comments": "Ghi chú",
    "signOrder": "Ký y lệnh",
    "holdOrder": "Tạm hoãn y lệnh",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "Danh mục y lệnh",
    "searchPlaceholder": "Tìm theo tên, mã hoặc từ đồng nghĩa…",
    "categories": "Phân loại",
    "favorites": "Yêu thích",
    "recentlyUsed": "Sử dụng gần đây",
    "restricted": "Hạn chế",
    "searchCatalog": "Tìm trong danh mục",
    "tabs": {
      "all": "Tất cả",
      "lab": "Xét nghiệm",
      "imaging": "Hình ảnh",
      "medication": "Thuốc",
      "procedure": "Thủ thuật",
      "consultation": "Hội chẩn"
    },
    "columns": {
      "orderName": "Tên y lệnh",
      "code": "Mã",
      "category": "Phân loại",
      "description": "Mô tả",
      "defaultPriority": "Mức ưu tiên mặc định"
    },
    "details": {
      "orderCode": "Mã y lệnh",
      "category": "Phân loại",
      "defaultPriority": "Mức ưu tiên mặc định",
      "status": "Trạng thái",
      "cptCode": "Mã CPT",
      "loincCode": "Mã LOINC",
      "synonyms": "Từ đồng nghĩa",
      "description": "Mô tả",
      "active": "Đang hoạt động",
      "inactive": "Không hoạt động"
    },
    "loading": "Đang tải danh mục…",
    "loadError": "Không tải được danh mục y lệnh",
    "emptyResults": "Không có y lệnh nào phù hợp.",
    "pagination": "Hiển thị {{from}}-{{to}} trong tổng số {{total}}",
    "pageIndicator": "Trang {{page}} / {{totalPages}}",
    "favoriteAdd": "Thêm vào yêu thích",
    "favoriteRemove": "Bỏ khỏi yêu thích",
    "favoriteAdded": "Đã thêm vào yêu thích",
    "favoriteRemoved": "Đã bỏ khỏi yêu thích"
  },
  "cosign": {
    "title": "Hàng đợi đồng ký y lệnh",
    "requiresCosign": "Cần đồng ký",
    "cosignedBy": "Người đồng ký",
    "cosignDeadline": "Hạn đồng ký",
    "queueEmpty": "Không có y lệnh cần đồng ký.",
    "pendingCount": "{{count}} chờ xử lý",
    "loading": "Đang tải hàng đợi đồng ký…",
    "loadError": "Không tải được hàng đợi đồng ký.",
    "columns": {
      "patient": "Bệnh nhân",
      "order": "Y lệnh",
      "type": "Loại",
      "orderingProvider": "Bác sĩ chỉ định",
      "priority": "Mức ưu tiên",
      "orderedDate": "Ngày chỉ định",
      "action": "Hành động"
    },
    "actions": {
      "cosign": "Đồng ký"
    },
    "toast": {
      "success": "Đã đồng ký y lệnh",
      "error": "Đồng ký y lệnh thất bại"
    },
    "cosigningAs": "Đồng ký với tư cách: {{name}}"
  },
  "sets": {
    "title": "Bộ y lệnh",
    "newOrderSet": "Bộ y lệnh mới",
    "addItem": "Thêm mục",
    "requiredItem": "Bắt buộc",
    "optionalItem": "Tùy chọn",
    "editMode": "Chế độ chỉnh sửa",
    "published": "Đã công bố",
    "draft": "Nháp",
    "archived": "Đã lưu trữ",
    "versionNotes": "Ghi chú phiên bản",
    "createTitle": "Tạo bộ y lệnh mới",
    "fields": {
      "name": "Tên",
      "category": "Phân loại",
      "specialty": "Chuyên khoa",
      "description": "Mô tả"
    },
    "placeholders": {
      "name": "VD: Tầm soát đau ngực",
      "categorySelect": "Chọn phân loại…",
      "specialty": "VD: Cấp cứu",
      "description": "Mô tả ngắn…",
      "search": "Tìm bộ y lệnh…"
    },
    "categories": {
      "chestPain": "Đau ngực",
      "sepsis": "Nhiễm khuẩn huyết",
      "postOp": "Sau mổ",
      "admission": "Nhập viện",
      "discharge": "Xuất viện",
      "other": "Khác"
    },
    "statusFilter": {
      "all": "Tất cả trạng thái",
      "active": "Đang hiệu lực",
      "draft": "Nháp",
      "archived": "Đã lưu trữ"
    },
    "columns": {
      "name": "Tên",
      "category": "Phân loại",
      "specialty": "Chuyên khoa",
      "items": "Số mục",
      "status": "Trạng thái",
      "version": "Phiên bản",
      "actions": "Hành động"
    },
    "itemColumns": {
      "seq": "STT",
      "type": "Loại",
      "item": "Mục",
      "priority": "Mức ưu tiên",
      "required": "Bắt buộc"
    },
    "itemTypes": {
      "order": "Y lệnh",
      "sectionHeader": "Tiêu đề phần",
      "instruction": "Hướng dẫn"
    },
    "actions": {
      "publish": "Công bố",
      "archive": "Lưu trữ",
      "cancel": "Hủy",
      "create": "Tạo",
      "removeItem": "Gỡ mục"
    },
    "loading": "Đang tải bộ y lệnh…",
    "loadError": "Không tải được bộ y lệnh",
    "emptyResults": "Không tìm thấy bộ y lệnh.",
    "expandLoading": "Đang tải mục…",
    "expandEmpty": "Bộ y lệnh này chưa có mục nào.",
    "validationRequired": "Tên, phân loại và chuyên khoa là bắt buộc",
    "toast": {
      "created": "Đã tạo bộ y lệnh",
      "createError": "Tạo bộ y lệnh thất bại",
      "published": "Đã công bố bộ y lệnh",
      "publishError": "Công bố bộ y lệnh thất bại",
      "archived": "Đã lưu trữ bộ y lệnh",
      "archiveError": "Lưu trữ bộ y lệnh thất bại",
      "itemRemoved": "Đã gỡ mục",
      "itemRemoveError": "Gỡ mục thất bại"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "Tìm y lệnh (xét nghiệm, hình ảnh, thuốc, thủ thuật)…",
    "noResults": "Không tìm thấy y lệnh nào cho \"{{query}}\"",
    "categories": {
      "all": "Tất cả",
      "lab": "Xét nghiệm",
      "imaging": "Hình ảnh",
      "med": "Thuốc",
      "procedure": "Thủ thuật",
      "consultation": "Hội chẩn"
    },
    "addAll": "Thêm tất cả {{count}}"
  },
  "worklist": {
    "title": "Danh sách công việc y lệnh",
    "countBadge": "{{count}} y lệnh",
    "loading": "Đang tải y lệnh…",
    "loadError": "Không thể tải y lệnh. Vui lòng thử lại.",
    "empty": "Không có y lệnh nào khớp với bộ lọc hiện tại.",
    "typeLabel": "Loại y lệnh",
    "allOption": "Tất cả",
    "columns": {
      "patient": "Bệnh nhân",
      "order": "Y lệnh",
      "type": "Loại",
      "priority": "Mức ưu tiên",
      "status": "Trạng thái",
      "ordered": "Ngày y lệnh"
    }
  }
}
